import React from 'react'
import PropTypes from 'prop-types'
import LoadingImage from '../../../utilities/images/loading-gif.svg'

function Loading (props) {
  const { className,wrapper } = props

  const getImageUrl = () => {
    let url = LoadingImage
    if(window.app_config && window.app_config.loading_icon){
      url = window.app_config.loading_icon
    }
    return url
  }




  if(wrapper){
    return (
      <div className={`of-loading-wrapper${className ? ' of-loading-wrapper--' + className : ''}`}>
        <div className={`of-loading${className ? ' ' + className : ''}`}>
          <img src={getImageUrl()} alt='Loading' className='of-loading__image' />
        </div>
      </div>
    )
  }
  return (
    <div className={`of-loading${className ? ' ' + className : ''}`}>
      <img src={getImageUrl()} alt='Loading' className='of-loading__image' />
    </div>
  )
}

Loading.propTypes = {
  className: PropTypes.string,
  wrapper: PropTypes.bool
}

export default Loading
